import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class AddToCartStateService {
  private addToCartForm: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.addToCartForm = this.formBuilder.group({
      quantity: [1]
    });
  }

  getForm(): FormGroup {
    return this.addToCartForm;
  }

  setQuantity(qty: number): void {
    this.addToCartForm.get('quantity')?.setValue(qty);
  }
}